module.exports = __webpack_public_path__ + "img/solution-pc-20.a0828861.png";